import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import FlagDetails from './flagDetails';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';

export default class AddFlag extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <ModalStyled
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.props.isOpen}
                onHide={this.props.handleClose}
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add New Flag</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FlagDetails
                        flagData={null} // null indicates creating new flag
                        context={this.props.context}
                        handleClose={this.props.handleClose}
                        isOpen={true}
                        isCreating={true}
                    />
                </Modal.Body>
            </ModalStyled>
        );
    }
}